function ImageInputWrapper({ handleChange, children }) {
  return (
    <label className="image_upload_trigger">
      <input
        type="file"
        accept="image/gif, image/jpeg, image/png"
        onChange={handleChange}
      />
      {children}
    </label>
  );
}

export default ImageInputWrapper;
